import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { HelpCircle } from 'lucide-react';
export function Objection() {
  return <Section background="white" data-id="element-249">
      <FadeIn data-id="element-250">
        <div className="max-w-2xl mx-auto text-center" data-id="element-251">
          <div className="inline-block p-3 bg-gray-100 rounded-full mb-6" data-id="element-252">
            <HelpCircle className="h-8 w-8 text-gray-500" data-id="element-253" />
          </div>

          <h2 className="text-3xl font-serif font-bold mb-6 text-[#1A1A1A]" data-id="element-254">
            "¿Y si me duele?"
          </h2>

          <div className="prose prose-lg mx-auto text-gray-600" data-id="element-255">
            <p className="mb-4" data-id="element-256">
              Te entiendo. Por eso el plan no se apoya en valentía.
              <br data-id="element-257" />
              <span className="font-bold text-[#1B4332]" data-id="element-258">
                Se apoya en reglas.
              </span>
            </p>

            <p className="mb-6" data-id="element-259">
              Si el semáforo dice amarillo, ajustás. Si dice rojo, retrocedés a
              Nivel 0.
            </p>

            <p className="italic font-medium text-[#1A1A1A]" data-id="element-260">
              Eso es lo que evita el ciclo de "me entusiasmé → me inflamé →
              abandoné".
            </p>
          </div>
        </div>
      </FadeIn>
    </Section>;
}